import { sva } from "@agapi/ui/panda/css";

export const sectionStyles = sva({
  slots: ['root', 'container'],
  variants: {
    direction: {
      'row-wrap': {
        container: {
          flexDirection: 'row',
          flexWrap: 'wrap',
        },
      },
      'column': {
        container: {
          flexDirection: 'column',
        },
      },
      'row': {
        container: {
          flexDirection: 'row',
        },
      },
    },
    verticalSpacing: {
      'none': {
        root: {
          pb: '0',
          pt: '0',
        },
      },
      'tight': {
        root: {
          pb: 'tight',
          pt: 'tight',
        },
      },
      'snug': {
        root: {
          pb: 'snug',
          pt: 'snug',
        },
      },
      'normal': {
        root: {
          pb: 'normal',
          pt: 'normal',
        },
      },
      'relaxed': {
        root: {
          pb: 'relaxed',
          pt: 'relaxed',
        },
      },
      'loose': {
        root: {
          pb: 'loose',
          pt: 'loose',
        },
      },
      '': {
      }
    },
  },
});